
  import { defineComponent } from 'vue'
  
  export default defineComponent({
    name: 'PatientCondition',
    data () {
        return {
          conditions: [
            {
              condition: 'Hypertension',
              doctor: 'Dr Phoebe',
              diagnosedOn: '2022-03-01'
            },
            {
              condition: 'Asthma',
              name: 'Beclomethazone thingy',
              dose: '40mcg',
              doctor: 'Dr Phoebe',
              diagnosedOn: '2021-01-01'
            },
            {
              condition: 'Hives',
              name: 'Ibuprofen',
              doctor: 'Dr Piper',
              diagnosedOn: '2022-03-01'
            },
            {
              condition: 'Diabetes',
              name: 'Ibuprofen',
              doctor: 'Dr Prue',
              diagnosedOn: '2022-03-01'
            },
            {
              condition: 'Anemic',
              name: 'Ibuprofen',
              doctor: 'Dr Paige',
              diagnosedOn: '2022-03-01'
            },
          ],
        }
      },
  })
  